import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {ref, watch} from "vue";
import {useRouter} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SelectProductTypeComponent from "@/modules/ShoppingCart/components/SelectProductTypeComponent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SelectProductComponent from "@/modules/ShoppingCart/components/SelectProductComponent.vue";
import {storeToRefs} from "pinia";
import {useNavigationStore} from "@/modules/Navigation/store";
import PremiumComponent from "@/modules/ShoppingCart/components/PremiumComponent.vue";
import CashPointComponent from "@/modules/ShoppingCart/components/cashPointComponent.vue";
import ProductPriceComponent from "@/modules/ShoppingCart/components/ProductPriceComponent.vue";
import StoreExportBlankComponent from "@/modules/ShoppingCart/components/StoreExportBlankComponent.vue";
import ExportBlankComponent from "@/modules/ShoppingCart/components/ExportBlankComponent.vue";
import EvbComponent from "@/modules/ShoppingCart/components/EvbComponent.vue";
import {InsuranceType} from "@/shared/model/insuranceType";


interface Props {
  sector?: string,
  page?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SingleProductPage',
  props: {
    sector: { default: "purchase" },
    page: { default: "producttype" }
  },
  setup(__props: any) {

const props = __props

const _router = useRouter();
const _title = ref("Template")
const _spinner = useSpinner()
const _navigationStore = useNavigationStore();
const _shoppingCartStore = useShoppingCartStore();
const {currentItem, currentShoppingCart} = storeToRefs(_shoppingCartStore);
const _page = ref("");
const _storeExportBlank = ref<InstanceType<typeof StoreExportBlankComponent> | null>(null)
const _exportBlank = ref<InstanceType<typeof ExportBlankComponent> | null>(null)


watch(props, async () => {
    _title.value = props.sector === "purchase" ? "Einzelnes Produkt kaufen" : ""
    _shoppingCartStore.setSingle(true);
    _page.value = props.page
    let t_start = "";
    if (props.sector === "purchase") {
      t_start = "/producttype"
      if (props.page === "producttype") {
        _shoppingCartStore.clear()
        await _shoppingCartStore.initPurchase();
      }
    } else {
      _navigationStore.back();
      return;
    }

    /*
  if (props.page === "product" && currentItem.value.baseProductType === undefined) {
    await _router.push({path: "/shoppingcartsingleproduct/" + props.sector, replace: true})
    return;
  }
*/

    switch (_page.value) {
      case "product":
        if (currentItem.value.baseProducts.length > 0) {
          break;
        } else {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
      case "productprice":
        if (currentItem.value.productPrices.length > 0) {
          break;
        } else {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
      case "premium":
        if (currentItem.value.shoppingCartItem.productPrice === undefined) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "storeexportblank":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        await _storeExportBlank.value?.loadStoreExportBlank();
        break;
      case "exportblank":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "evb":
        if (currentShoppingCart.value.items.find(t => t.insuranceType === InsuranceType.Kzk)?.count === 0) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        break;
      case "store":
        if (!currentItem.value.shoppingCartItem.productPrice) {
          await _router.push({path: "/shoppingcartsingleproduct/" + props.sector + t_start, replace: true})
          return;
        }
        //await p_loadStore();
        break;
    }
  }
  ,
  {immediate: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { class: "sog-card-without-title" }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SelectProductTypeComponent, null, null, 512), [
                [_vShow, _page.value==='producttype']
              ]),
              _withDirectives(_createVNode(SelectProductComponent, null, null, 512), [
                [_vShow, _page.value==='product']
              ]),
              _withDirectives(_createVNode(ProductPriceComponent, null, null, 512), [
                [_vShow, _page.value === 'productprice']
              ]),
              _withDirectives(_createVNode(PremiumComponent, null, null, 512), [
                [_vShow, _page.value === 'premium']
              ]),
              _withDirectives(_createVNode(StoreExportBlankComponent, {
                ref_key: "_storeExportBlank",
                ref: _storeExportBlank
              }, null, 512), [
                [_vShow, _page.value === 'storeexportblank']
              ]),
              _withDirectives(_createVNode(ExportBlankComponent, null, null, 512), [
                [_vShow, _page.value === 'exportblank']
              ]),
              _withDirectives(_createVNode(EvbComponent, null, null, 512), [
                [_vShow, _page.value==='evb']
              ]),
              _withDirectives(_createVNode(CashPointComponent, null, null, 512), [
                [_vShow, _page.value === 'cashpoint']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})